export default __webpack_public_path__ + "static/media/twitter-min.3d95843c.jpg";